import { render, staticRenderFns } from "./Last28Days.vue?vue&type=template&id=18f268fa"
import script from "./Last28Days.vue?vue&type=script&lang=js"
export * from "./Last28Days.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports